/**
 * Direct deep-link screen for the targeted follow-up queue.
 */
import { formatInteger } from "./format.js";
import { fetchJson } from "./dashboard-lead-factory-fetch.js";
import { followUpQueueUrl } from "./dashboard-saved-view-state.js";
import { leadFactoryFollowUpQueueUrl } from "./dashboard-urls.js";
import { followUpTaskHtml } from "./dashboard-contact-policy.js";
import type { LeadFactoryTasksResponse } from "./dashboard-lead-factory-types.js";

export function directFollowUpRequested(): boolean {
  const value = new URLSearchParams(window.location.search).get("lf_follow_up_direct")?.trim().toLowerCase() ?? "";
  return value === "1" || value === "true";
}

export async function renderDirectFollowUp(
  mount: HTMLElement,
  bindActions: (statusElement: HTMLElement) => void
): Promise<void> {
  const followUpQueue = await fetchJson<LeadFactoryTasksResponse>(followUpQueueUrl(leadFactoryFollowUpQueueUrl));
  mount.innerHTML = `
    <main class="dashboard-shell follow-up-direct" data-follow-up-direct>
      <section class="panel">
        <div class="panel-heading">
          <div>
            <h1>Follow Up</h1>
            <p class="subtle">${formatInteger(followUpQueue.tasks.length)} targeted follow-up tasks loaded</p>
          </div>
          <a class="button secondary" href="/">Dashboard</a>
        </div>
        <div class="task-list">
          ${followUpQueue.tasks.map(followUpTaskHtml).join("") || `<p class="empty">No targeted follow-up task is loaded.</p>`}
        </div>
      </section>
      <aside id="county-detail" class="detail-drawer" aria-live="polite"></aside>
      <p id="action-status" class="action-status" role="status" aria-live="polite">Follow-up queue loaded.</p>
    </main>
  `;
  const statusElement = document.querySelector<HTMLElement>("#action-status");
  if (!statusElement) throw new Error("Missing dashboard element #action-status");
  bindActions(statusElement);
}
